import React, { useEffect, useState } from "react";
import explore_products_1 from "./../../assets/images/dummy/explore_products_1.png";
import explore_products_2 from "./../../assets/images/dummy/explore_products_2.jpeg";
import rightArrow from "../../assets/images/icons/rightArrow.png";

import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { Col, Row } from "react-bootstrap";
import Y_Us_StripComponent from "../common/Y_us_strip";
import Constants from "../Variables/Constants";
import { NavLink, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import NoData from "../../components/NoData";

const SelectToCompare = ({
  images,
  handleAddToCart,
  handleRemove,
  categoryId,
  collectionId,
  categoryData,
  collectionName,
}) => {
  const navigate = useNavigate();
  const [firstSelected, setFirstSelected] = useState(
    images?.length > 0
      ? Constants?.imgDomain + images?.[0]?.customized_image
      : null
  );
  const [secondSelected, setSecondSelected] = useState(null);
  const [lastActive, setLastActive] = useState(null);

  const parseJsonValue = (value) => {
    if (!value) return null;
    if (typeof value === "string") {
      try {
        return JSON.parse(value);
      } catch (e) {
        return null;
      }
    }
    return typeof value === "object" ? value : null;
  };

  const getSelectionAddOns = (selection) => {
    const designData =
      parseJsonValue(selection?.design_data) ||
      parseJsonValue(selection?.customized_image_id?.design_data) ||
      parseJsonValue(selection?.customize_image_id?.design_data) ||
      selection?.customized_image_id ||
      selection?.customize_image_id ||
      selection;

    const addOns =
      designData?.addOns ||
      designData?.add_ons ||
      selection?.addOns ||
      selection?.add_ons;

    return Array.isArray(addOns) ? addOns : [];
  };

  const formatPrice = (price) => Number(price || 0).toFixed(2);

  const renderAddOnsDetails = (selection) => {
    if (!selection) return null;

    const addOns = getSelectionAddOns(selection);

    return (
      <div className="mt-3 pt-3 border-top">
        <h6 className="fw-bold mb-2 text-primary">Add-ons Selected:</h6>
        {addOns.length > 0 ? (
          <ul className="list-unstyled mb-0">
            {addOns.map((addon, index) => {
              const quantity = Number(addon.quantity || 1);
              const price = Number(addon.price || 0);

              return (
                <li
                  key={addon.id || addon.addOnId || addon._id || index}
                  className="mb-2 d-flex justify-content-between gap-3"
                >
                  <div>
                    <strong>{addon.name || addon.title || "Add-on"}</strong>
                    {addon.groupTitle && (
                      <div className="text-muted small">{addon.groupTitle}</div>
                    )}
                    {quantity > 1 && (
                      <span className="badge bg-secondary mt-1">
                        x{quantity}
                      </span>
                    )}
                  </div>
                  {price > 0 && (
                    <span className="text-muted small whiteSpaceNo">
                      ${formatPrice(price)}
                      {quantity > 1 ? " each" : ""}
                    </span>
                  )}
                </li>
              );
            })}
          </ul>
        ) : (
          <p className="text-muted small mb-0">No add-ons selected</p>
        )}
      </div>
    );
  };

  useEffect(() => {
    if (images.length > 0) {
      if (!firstSelected) {
        const firstImage = images[0];
        setFirstSelected({ ...firstImage });
        setLastActive("first");
      }

      if (!secondSelected && images.length > 1) {
        const secondImage = images[1];
        setSecondSelected({ ...secondImage });
        setLastActive("second");
      }
    }
  }, [images]);

  return (
    <div className="container-fluid mt-5 px-5">
      <nav className="mb-5 mt-2 font-poppins route-navigation">
        <ul className="d-flex gap-4 text-light-gray fs-20 fw-bold ">
          {" "}
          <li className="list-unstyled">
            <NavLink to={"/"}>HOME </NavLink>
          </li>
          <li className="list-unstyled">
            <img loading="lazy" src={rightArrow} alt="" />
          </li>
          <NavLink to={`/category?catid=${categoryId}`}>
            <li className="list-unstyled whiteSpaceNo me-5">
              {categoryData?.title}
            </li>
          </NavLink>
          <li className="list-unstyled">
            <img loading="lazy" src={rightArrow} alt="" />
          </li>
          <NavLink
            to={`/category/collection?catid=${categoryData?._id}&collectionId=${collectionId}`}
          >
            <li className="list-unstyled">{collectionName}</li>
          </NavLink>
          <li className="list-unstyled">
            <img loading="lazy" src={rightArrow} alt="" />
          </li>
          <NavLink
            to={`/customize?productId=${images?.[0]?.product_id}&isEdit=true&customizeImageId=${images?.[0]?._id}&categoryId=${categoryId}&collectionId=${collectionId}`}
          >
            <li className="list-unstyled">Customize Product</li>
          </NavLink>
          <li className="list-unstyled">
            <img loading="lazy" src={rightArrow} alt="" />
          </li>
          <NavLink
            to="#"
            onClick={(e) => {
              e.preventDefault();
            }}
          >
            <li className="list-unstyled text-dark">Compare Design</li>
          </NavLink>
        </ul>
      </nav>
      <div className="row gap-4 justify-content-center flex-wrap align-items-start mt-4">
        {/* First Selection */}
        <div className="col-md-5 col-12 text-center p-1 rounded-5">
          <div className="d-flex gap-4 justify-content-center flex-column flex-xl-row">
            <div className="mt-3 d-flex gap-3 flex-column order-1 order-xxl-0 justify-content-center">
              <button
                className="btn text-white h-fit whiteSpaceNo btn-warning"
                type="button"
                onClick={() => {
                  if (firstSelected && firstSelected?._id) {
                    if (firstSelected?.product_id) {
                      navigate(
                        `/customize?productId=${firstSelected?.product_id}&isEdit=true&customizeImageId=${firstSelected?._id}&categoryId=${categoryId}&collectionId=${collectionId}`
                      );
                    } else {
                      navigate(
                        `/customize?categoryId=${categoryId}&collectionId=${collectionId}&isEdit=true&customizeImageId=${firstSelected?._id}`
                      );
                    }
                  } else {
                    toast.error("Please select a product");
                  }
                }}
              >
                Edit
              </button>
              <button
                type="button"
                className="btn text-white h-fit whiteSpaceNo btn-warning me-3"
                onClick={() => {
                  setFirstSelected(null);
                  setLastActive("first");
                }}
              >
                Change
              </button>
              <button
                className="btn text-white h-fit whiteSpaceNo btn-warning"
                onClick={() => {
                  if (firstSelected) {
                    if (!localStorage.getItem("token")) {
                      toast.error("Please login to add to cart");
                      navigate("/login", {
                        state: {
                          locationPath: window.location.href,
                          data: null,
                        },
                      });
                    } else {
                      handleAddToCart(firstSelected);
                    }
                  } else {
                    toast.clearWaitingQueue();
                    toast.dismiss();
                    toast.error("Please select a design to add to cart.");
                  }
                }}
              >
                Add To Cart
              </button>
            </div>
            <div className="order-0 order-xxl-1">
              <img
                loading="eager"
                src={
                  firstSelected
                    ? `${Constants.imgDomain + firstSelected.customized_image}`
                    : `/select.png`
                }
                alt="Design 1"
                className="img-fluid prodImg3"
              />
              
              {/* Pricing and Add-ons Details */}
              {firstSelected && (
                <div className="mt-3 p-3 bg-light rounded text-start">
                  <h5 className="fw-bold mb-3">Price Details</h5>
                  
                  {/* Price Breakdown */}
                  {firstSelected.price_data && typeof firstSelected.price_data === 'string' ? (
                    (() => {
                      try {
                        const priceData = JSON.parse(firstSelected.price_data);
                        return (
                          <div className="mb-3">
                            {priceData.fabric_price > 0 && (
                              <div className="d-flex justify-content-between mb-2">
                                <span>Fabric:</span>
                                <span className="fw-semibold">${priceData.fabric_price.toFixed(2)}</span>
                              </div>
                            )}
                            {priceData.art1_design_price > 0 && (
                              <div className="d-flex justify-content-between mb-2">
                                <span>Art1 Design:</span>
                                <span className="fw-semibold">${priceData.art1_design_price.toFixed(2)}</span>
                              </div>
                            )}
                            {priceData.art2_design_price > 0 && (
                              <div className="d-flex justify-content-between mb-2">
                                <span>Art2 Design:</span>
                                <span className="fw-semibold">${priceData.art2_design_price.toFixed(2)}</span>
                              </div>
                            )}
                            {priceData.accent_price > 0 && (
                              <div className="d-flex justify-content-between mb-2">
                                <span>Accent Color:</span>
                                <span className="fw-semibold">${priceData.accent_price.toFixed(2)}</span>
                              </div>
                            )}
                            {priceData.text_price > 0 && (
                              <div className="d-flex justify-content-between mb-2">
                                <span>Personalization:</span>
                                <span className="fw-semibold">${priceData.text_price.toFixed(2)}</span>
                              </div>
                            )}
                            {priceData.add_ons_price > 0 && (
                              <div className="d-flex justify-content-between mb-2">
                                <span>Add-ons:</span>
                                <span className="fw-semibold">${priceData.add_ons_price.toFixed(2)}</span>
                              </div>
                            )}
                            {priceData.matching_bag && typeof priceData.matching_bag === 'string' && (() => {
                              try {
                                const matchingBag = JSON.parse(priceData.matching_bag);
                                if (matchingBag.price > 0) {
                                  return (
                                    <div className="d-flex justify-content-between mb-2">
                                      <span>Matching Bag:</span>
                                      <span className="fw-semibold">${matchingBag.price.toFixed(2)}</span>
                                    </div>
                                  );
                                }
                              } catch (e) {
                                return null;
                              }
                            })()}
                            <hr />
                            <div className="d-flex justify-content-between">
                              <span className="fw-bold">Total:</span>
                              <span className="fw-bold text-success">${priceData.total_price?.toFixed(2) || firstSelected.price?.toFixed(2)}</span>
                            </div>
                          </div>
                        );
                      } catch (e) {
                        return (
                          <div className="d-flex justify-content-between">
                            <span className="fw-bold">Total Price:</span>
                            <span className="fw-bold text-success">${firstSelected.price?.toFixed(2) || '0.00'}</span>
                          </div>
                        );
                      }
                    })()
                  ) : (
                    <div className="d-flex justify-content-between">
                      <span className="fw-bold">Total Price:</span>
                      <span className="fw-bold text-success">${firstSelected.price?.toFixed(2) || '0.00'}</span>
                    </div>
                  )}
                  
                  {renderAddOnsDetails(firstSelected)}
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Second Selection */}
        <div className="col-md-5 col-12 text-center p-3 rounded-5">
          <div className="d-flex gap-4 justify-content-center flex-column flex-xl-row">
            <div>
              <img
                loading="eager"
                src={
                  secondSelected
                    ? `${Constants.imgDomain + secondSelected.customized_image}`
                    : `/select.png`
                }
                alt="Design 2"
                className="img-fluid prodImg3"
              />
              
              {/* Pricing and Add-ons Details */}
              {secondSelected && (
                <div className="mt-3 p-3 bg-light rounded text-start">
                  <h5 className="fw-bold mb-3">Price Details</h5>
                  
                  {/* Price Breakdown */}
                  {secondSelected.price_data && typeof secondSelected.price_data === 'string' ? (
                    (() => {
                      try {
                        const priceData = JSON.parse(secondSelected.price_data);
                        return (
                          <div className="mb-3">
                            {priceData.fabric_price > 0 && (
                              <div className="d-flex justify-content-between mb-2">
                                <span>Fabric:</span>
                                <span className="fw-semibold">${priceData.fabric_price.toFixed(2)}</span>
                              </div>
                            )}
                            {priceData.art1_design_price > 0 && (
                              <div className="d-flex justify-content-between mb-2">
                                <span>Art1 Design:</span>
                                <span className="fw-semibold">${priceData.art1_design_price.toFixed(2)}</span>
                              </div>
                            )}
                            {priceData.art2_design_price > 0 && (
                              <div className="d-flex justify-content-between mb-2">
                                <span>Art2 Design:</span>
                                <span className="fw-semibold">${priceData.art2_design_price.toFixed(2)}</span>
                              </div>
                            )}
                            {priceData.accent_price > 0 && (
                              <div className="d-flex justify-content-between mb-2">
                                <span>Accent Color:</span>
                                <span className="fw-semibold">${priceData.accent_price.toFixed(2)}</span>
                              </div>
                            )}
                            {priceData.text_price > 0 && (
                              <div className="d-flex justify-content-between mb-2">
                                <span>Personalization:</span>
                                <span className="fw-semibold">${priceData.text_price.toFixed(2)}</span>
                              </div>
                            )}
                            {priceData.add_ons_price > 0 && (
                              <div className="d-flex justify-content-between mb-2">
                                <span>Add-ons:</span>
                                <span className="fw-semibold">${priceData.add_ons_price.toFixed(2)}</span>
                              </div>
                            )}
                            {priceData.matching_bag && typeof priceData.matching_bag === 'string' && (() => {
                              try {
                                const matchingBag = JSON.parse(priceData.matching_bag);
                                if (matchingBag.price > 0) {
                                  return (
                                    <div className="d-flex justify-content-between mb-2">
                                      <span>Matching Bag:</span>
                                      <span className="fw-semibold">${matchingBag.price.toFixed(2)}</span>
                                    </div>
                                  );
                                }
                              } catch (e) {
                                return null;
                              }
                            })()}
                            <hr />
                            <div className="d-flex justify-content-between">
                              <span className="fw-bold">Total:</span>
                              <span className="fw-bold text-success">${priceData.total_price?.toFixed(2) || secondSelected.price?.toFixed(2)}</span>
                            </div>
                          </div>
                        );
                      } catch (e) {
                        return (
                          <div className="d-flex justify-content-between">
                            <span className="fw-bold">Total Price:</span>
                            <span className="fw-bold text-success">${secondSelected.price?.toFixed(2) || '0.00'}</span>
                          </div>
                        );
                      }
                    })()
                  ) : (
                    <div className="d-flex justify-content-between">
                      <span className="fw-bold">Total Price:</span>
                      <span className="fw-bold text-success">${secondSelected.price?.toFixed(2) || '0.00'}</span>
                    </div>
                  )}
                  
                  {renderAddOnsDetails(secondSelected)}
                </div>
              )}
            </div>
            <div className="mt-3 d-flex gap-3 flex-column justify-content-center">
              <button
                className="btn text-white h-fit whiteSpaceNo btn-warning"
                type="button"
                onClick={() => {
                  if (secondSelected && secondSelected?._id) {
                    if (secondSelected?.product_id) {
                      navigate(
                        `/customize?productId=${secondSelected?.product_id}&isEdit=true&customizeImageId=${secondSelected?._id}&categoryId=${categoryId}&collectionId=${collectionId}`
                      );
                    } else {
                      navigate(
                        `/customize?categoryId=${categoryId}&collectionId=${collectionId}&isEdit=true&customizeImageId=${secondSelected?._id}`
                      );
                    }
                  } else {
                    toast.error("Please select a product");
                  }
                }}
              >
                Edit
              </button>
              <button
                type="button"
                className="btn text-white h-fit whiteSpaceNo btn-warning me-3"
                onClick={() => {
                  setSecondSelected(null);
                  setLastActive("second");
                }}
              >
                Change
              </button>
              <button
                className="btn text-white h-fit whiteSpaceNo btn-warning"
                onClick={() => {
                  if (secondSelected) {
                    if (!localStorage.getItem("token")) {
                      toast.error("Please login to add to cart");
                      navigate("/login", {
                        state: {
                          locationPath: window.location.href,
                          data: null,
                        },
                      });
                    } else {
                      handleAddToCart(secondSelected);
                    }
                  } else {
                    toast.clearWaitingQueue();
                    toast.dismiss();
                    toast.error("Please select a design to add to cart.");
                  }
                }}
              >
                Add To Cart
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Explore Collections */}
      <div className="container-fluid my-5">
        <div className="d-flex mb-3">
          <h2 className={`hdng1 w-100`}>Saved Design</h2>
        </div>
        <Swiper
          modules={[Navigation, Pagination]}
          navigation
          pagination={{ clickable: true }}
          spaceBetween={20}
          breakpoints={{
            1: { slidesPerView: 1 },
            450: { slidesPerView: 2 },
            750: { slidesPerView: 3 },
            1000: { slidesPerView: 3 },
            1225: { slidesPerView: 4 },
            1500: { slidesPerView: 5 },
          }}
          className="swiper-container"
        >
          {images.length > 0 &&
            images.map((product) => (
              <SwiperSlide
                key={product._id}
                className="explore_our_products_card rounded-1 m-2"
              >
                <img
                  loading="lazy"
                  src={Constants.imgDomain + product.customized_image}
                  className="prodImg3"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    const isFirstSelected = firstSelected?._id === product._id;
                    const isSecondSelected =
                      secondSelected?._id === product._id;

                    if (isFirstSelected || isSecondSelected) {
                      toast.clearWaitingQueue();
                      toast.dismiss();
                      toast.error("You have already selected this design.");
                      return;
                    }

                    if (!firstSelected) {
                      setFirstSelected({ ...product });
                      setLastActive("first");
                    } else if (!secondSelected) {
                      setSecondSelected({ ...product });
                      setLastActive("second");
                    } else {
                      if (lastActive === "first") {
                        setFirstSelected({ ...product });
                      } else if (lastActive === "second") {
                        setSecondSelected({ ...product });
                      } else {
                        setFirstSelected({ ...product });
                        setLastActive("first");
                      }
                    }
                  }}
                  alt="Product"
                />

                {(secondSelected?._id === product._id ||
                  firstSelected?._id === product._id) && (
                  <div
                    onClick={() => {
                      if (secondSelected?._id === product._id) {
                        setSecondSelected(null);
                        setLastActive("second");
                      } else {
                        setFirstSelected(null);
                        setLastActive("first");
                      }
                    }}
                    style={{ cursor: "pointer" }}
                    className="position-absolute bg-xx active z-3 h-100 w-100 d-flex justify-content-center align-items-center top-0 right-0"
                  >
                    <img
                      loading="lazy"
                      src="https://png.pngtree.com/png-vector/20221215/ourmid/pngtree-green-check-mark-png-image_6525691.png"
                      alt="Active"
                      className="w-25 h-25 p-1"
                    />
                  </div>
                )}

                <img
                  loading="lazy"
                  width={20}
                  className="position-absolute cursor closey top-0 h-25 end-0 w-25"
                  src="/closey.png"
                  alt="Close"
                  onClick={() => handleRemove(product)}
                />
              </SwiperSlide>
            ))}
        </Swiper>

        {images.length === 0 && (
          <NoData
            text="Please select at least 2 design."
            image="https://static.vecteezy.com/system/resources/thumbnails/010/856/652/small_2x/no-result-data-document-or-file-not-found-concept-illustration-flat-design-eps10-modern-graphic-element-for-landing-page-empty-state-ui-infographic-icon-etc-vector.jpg"
          />
        )}
      </div>
      <Y_Us_StripComponent />
    </div>
  );
};

export default SelectToCompare;

/* -------------------------------------------------------- */

/* const [design1, setDesign1] = useState({
        imgSrc: "/empty.png", // Placeholder image for Design 1
      added: false,
  });

      const [design2, setDesign2] = useState({
        imgSrc: "/empty.png",
      added: false,
  });

  const handleAddToCart = (designIndex) => {
    if (designIndex === 1) {
        setDesign1((prev) => ({ ...prev, added: true }));
    } else {
        setDesign2((prev) => ({ ...prev, added: true }));
    }
  };

  const handleChangeDesign = (designIndex) => {
    if (designIndex === 1) {
        setDesign1({
          imgSrc: "/empty.png",
          added: false,
        });
    } else {
        setDesign2({ imgSrc: "/empty.png", added: false });
    }
  }; */

{
  /*  {images.map((image, i) => (
          <div className="col-md-5 col-12 text-center p-3  rounded-5">
            <div className="d-flex gap-4 justify-content-center flex-wrap">
              {" "}
              {i === 0 && (
                <div className="mt-3 d-flex gap-3 flex-column  justify-content-center">
                  <button
                    className="btn text-white h-fit whiteSpaceNo btn-warning  me-3"
                    onClick={() => handleRemove(image._id)}
                  >
                    Change
                  </button>
                  <button
                    className="btn text-white h-fit whiteSpaceNo btn-warning"
                    onClick={() => handleAddToCart(image)}
                  >
                    Add To Cart
                  </button>
                </div>
              )}
              <img loading="lazy" 
                src={`${Constants.imgDomain}${image.customized_image}`}
                alt="Design 2"
                className="img-fluid prodImg3"
              />
              {i === 1 && (
                <div className="mt-3 d-flex gap-3 flex-column  justify-content-center">
                  <button
                    className="btn text-white h-fit whiteSpaceNo btn-warning  me-3"
                    onClick={() => handleRemove(image._id)}
                  >
                    Change
                  </button>
                  <button
                    className="btn text-white h-fit whiteSpaceNo btn-warning"
                    onClick={() => handleAddToCart(image)}
                  >
                    Add To Cart
                  </button>
                </div>
              )}
            </div>
          </div>
        ))} */
}

{
  /* {images.length === 0 && (
          <>
            <div className="col-md-5 col-12 text-center p-3  rounded-5">
              <div className="d-flex gap-4 justify-content-center flex-wrap">
                {" "}
                <div className="mt-3 d-flex gap-3 flex-column  justify-content-center">
                  <button
                    className="btn text-white h-fit whiteSpaceNo btn-warning  me-3"
                    onClick={() => handleRemove()}
                  >
                    Change
                  </button>
                  <button
                    className="btn text-white h-fit whiteSpaceNo btn-warning"
                    onClick={() => handleAddToCart()}
                  >
                    Add To Cart
                  </button>
                </div>
                <img loading="lazy" 
                  src={`/select.png`}
                  alt="Design 2"
                  className="img-fluid prodImg3"
                />
              </div>
            </div>
            <div className="col-md-5 col-12 text-center p-3  rounded-5">
              <div className="d-flex gap-4 justify-content-center flex-wrap">
                {" "}
                <img loading="lazy" 
                  src={`/select.png`}
                  alt="Design 2"
                  className="img-fluid prodImg3"
                />
                <div className="mt-3 d-flex gap-3 flex-column  justify-content-center">
                  <button
                    className="btn text-white h-fit whiteSpaceNo btn-warning  me-3"
                    onClick={() => handleRemove()}
                  >
                    Change
                  </button>
                  <button
                    className="btn text-white h-fit whiteSpaceNo btn-warning"
                    onClick={() => handleAddToCart()}
                  >
                    Add To Cart
                  </button>
                 
                 
                </div>
              </div>
            </div>
          </>
        )} */
}

{
  /* Design 2 */
}
{
  /*  <div className="col-md-5 col-12 text-center p-3  rounded-5">
          <div className="d-flex gap-4 justify-content-center flex-wrap">
            {" "}
            {design2.imgSrc ? (
              <img loading="lazy" 
                src={design2.imgSrc || "https://via.placeholder.com/400"}
                alt="Design 2"
                className="img-fluid prodImg3"
              />
            ) : (
              <div className="text-muted">Select Design</div>
            )}
            <div className="mt-3 d-flex gap-3  justify-content-center">
              <button
                className="btn btn-warning"
                onClick={() => handleAddToCart(2)}
                disabled={!design2.imgSrc || design2.added}
              >
                {design2.added ? "Added to Cart" : "ADD TO Cart"}
              </button>
              <button
                className="btn btn-outline-warning"
                onClick={() => handleChangeDesign(2)}
                disabled={!design2.imgSrc}
              >
                Change
              </button>
            </div>
          </div>
        </div> */
}
